<template>
  <v-container class="page">
    <Headline
      :title="headlineText"
      icon="mdi-package-variant-closed"
    />
    <DriveTypeTable
      ref="driveTypeTable"
      @setPageMode="setPageMode"
      @cancel="headlineText = $t('condAdmin.driveTypeList.headline')"
    />
  </v-container>
</template>

<script lang="js">
import Headline from '@/common/Headline';
import DriveTypeTable from './components/DriveTypeTable.vue';

export default {
  name: 'DriveType',
  components: {
    Headline,
    DriveTypeTable
  },
  data () {
    return {
      pageMode: 'table', // values: table, edit
      headlineText: this.$t('condAdmin.driveTypeList.headline')
    };
  },
  async beforeRouteLeave (to, from, next) {
    if (await this.$refs.driveTypeTable.checkLeave() === true) next();
  },
  methods: {
    setPageMode (mode) {
      this.pageMode = mode;
      switch (mode) {
        case 'create':
          this.headlineText = this.$t('condAdmin.driveTypeList.driveTypeCreate');
          break;
        case 'edit':
          this.headlineText = this.$t('condAdmin.driveTypeList.driveTypeEdit');
          break;
        default: // 'table':
          this.headlineText = this.$t('condAdmin.driveTypeList.headline');
          break;
      }
    }
  }
};
</script>

<style scoped>
</style>
